/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useFirestore } from 'react-redux-firebase';
import collections from '../constants/FirestoreCollections';
import propTypes from 'prop-types';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { actions } from '../actions';
import { useDispatch } from 'react-redux';
import { setB } from '../utils/utils';
import moment from 'moment';
const MySwal = withReactContent(Swal);

const useStyles = () => {
  return makeStyles((theme) => ({
    header: {
      background: theme.palette.black.main,
      height: '75px',
    },
    title: {
      color: theme.palette.white.main,
    },
    checkboxLabel: {
      fontWeight: 'bold',
    },
    mainBtn: {
      width: 'fit-content',
    },
    disableNotifications: {
      color: '#CDBABA',
      fontSize: theme.sizes.sm.t2,
    },
    disableNotificationsLink: {
      color: '#7558D7',
      fontSize: theme.sizes.sm.t1,
      textDecoration: 'underline',
      width: 'fit-content',
      cursor: 'pointer',
      '&:hover': {
        fontSize: 13,
      },
    },
    privacyRow: {
      display: 'flex',
      alignItems: 'flex-start',
      paddingBlock: 16,
      cursor: 'pointer',
    },
    clientName: {
      fontWeight: 'bold',
      fontSize: 18,
      textTransform: 'uppercase',
    },
    privacyPoliciesTitle: {
      marginBottom: 8,
      fontSize: 22,
      fontWeight: 'light',
    },
    privacyPolicies: {
      textAlign: 'justify',
    },
  }));
};

function Reminder(props) {
  const { reminder, handleCancel, handleConfirm } = props;
  const small = useMediaQuery('(max-width:600px)');

  const onCancel = () => {
    MySwal.fire({
      text: '¿Esta seguro que desea CANCELAR su turno?',
      confirmButtonText: 'Si',
      showConfirmButton: true,
      showDenyButton: true,
      icon: 'info',
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleCancel(reminder);
      }
    });
  };

  const isOld =
    reminder.appDate &&
    reminder.appTime &&
    moment() > moment(`${reminder.appDate}${reminder.appTime}`, 'DD/MM/YYYY HH:mm');

  return (
    <Card
      variant="elevation"
      sx={{
        width: 'fit-content',
        mb: 2,
        p: 2,
        border: '1px solid #ccc',
        maxWidth: '100%',
      }}
    >
      <Typography sx={{ fontSize: 24, mb: 1 }}>{reminder.organizationName}</Typography>
      {!isOld && !reminder.isCancelled && (
        <Typography sx={{ textAlign: 'justify' }}>
          Estimado/a <b>{reminder.patientName}</b> DNI <b>{reminder.patientDNI}</b>, el día{' '}
          <b>{reminder.appDate}</b> a las <b>{reminder.appTime}hs</b> usted tiene un turno para{' '}
          <b>{reminder.serviceName}</b> con el/la profesional <b>{reminder.professionalName}</b>, en
          la sucursal ubicada en <b>{reminder.subsidiaryAddress}</b>.
        </Typography>
      )}
      {(isOld || reminder.isCancelled) && (
        <Typography>
          <Typography>
            Fecha: {reminder.appDate} {reminder.appTime}
          </Typography>
          <Typography>Especialidad: {reminder.serviceName}</Typography>
          <Typography>Profesional: {reminder.professionalName}</Typography>
        </Typography>
      )}

      {!isOld && !reminder.isConfirmed && !reminder.isCancelled && (
        <Typography sx={{ my: 2, textAlign: 'center' }}>
          ¿Desea <b>CONFIRMAR</b> o <b>CANCELAR</b> su turno?
        </Typography>
      )}
      <Box sx={{ display: 'flex', mt: 2 }}>
        {/* {reminder && reminder.isCancelled && (
          <Button variant="outlined" disabled sx={{ minWidth: '200px', mr: 1, flex: 1 }}>
            Cancelado
          </Button>
        )} */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: small ? 'column' : 'row',
            width: '100%',
          }}
        >
          {reminder && isOld && (reminder.isConfirmed || reminder.isCancelled) && (
            <Button
              disabled
              variant="contained"
              color="success"
              sx={{ minWidth: '200px', mr: !small && 1, flex: 1 }}
              onClick={() => handleConfirm(reminder)}
            >
              {reminder.isConfirmed ? 'CONFIRMADO' : 'CANCELADO'}
            </Button>
          )}
          {reminder && !isOld && reminder.isCancelled && (
            <Button
              disabled
              variant="contained"
              color="success"
              sx={{ minWidth: '200px', mr: !small && 1, flex: 1 }}
              onClick={() => handleConfirm(reminder)}
            >
              CANCELADO
            </Button>
          )}
          {reminder && !isOld && !reminder.isConfirmed && !reminder.isCancelled && (
            <Button
              variant="contained"
              color="success"
              sx={{ minWidth: '200px', mr: !small && 1, flex: 1 }}
              onClick={() => handleConfirm(reminder)}
            >
              CONFIRMAR TURNO
            </Button>
          )}
          {reminder && !isOld && (!reminder.isCancelled || reminder.isConfirmed) && (
            <Button
              variant="contained"
              color="error"
              sx={{
                minWidth: '200px',
                ml: !small && 1,
                my: small && 2,
                flex: (!reminder.isConfirmed || small) && 1,
              }}
              onClick={onCancel}
            >
              CANCELAR TURNO
            </Button>
          )}
        </Box>
      </Box>
    </Card>
  );
}

function PatientReminders() {
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  // redux
  // hooks
  // const firebase = useFirebase();
  const firestore = useFirestore();
  const history = useHistory();

  // states
  const [patientData, setPatientData] = useState({});
  const [loading, setLoading] = useState(true);
  const [phone, setPhone] = useState('');

  const search = useLocation().search;
  const phoneQuery = new URLSearchParams(search).get('phone');
  const appDispatch = useDispatch();

  useEffect(() => {
    if (phoneQuery) {
      firestore
        .collection(collections.patients)
        .doc(phoneQuery)
        .get()
        .then((res) => {
          const patient = res.data();
          if (patient) {
            setPatientData(patient);
          }
          setLoading(false);
        });
    }
  }, [firestore, phoneQuery]);

  const changePhone = () => {
    const _phone = phone.indexOf('549') === -1 ? `549${phone}` : phone;
    history.push(`/patient-reminders?phone=${_phone}`);
  };

  const handleSubmit = (reminder, isConfirmation) => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        session: reminder.session,
        gsid: reminder.messageId,
        queryResult: {
          parameters: {},
          action: `confirmar.turno.${isConfirmation ? 'si' : 'no'}`,
          intent: {
            displayName: `GESTION.notificaciones.confirmar_turno.${isConfirmation ? 'si' : 'no'}`,
          },
          outputContexts: [],
          queryText: `${isConfirmation ? 'CONFIRMAR TURNO' : 'CANCELAR TURNO'}`,
          fulfillmentMessages: [
            {
              text: {
                text: [''],
              },
            },
          ],
        },
      },
    };
    axios(process.env.REACT_APP_GENERIC_WEBHOOK_URL, requestOptions)
      .then((res) => {
        const data = res.data;
        const isError = data.isError || data.fulfillmentText.indexOf('error') !== -1;
        if (!isError) {
          const newNotifications = notifications.map((e) =>
            e.msgId !== reminder.msgId
              ? e
              : {
                  ...e,
                  isConfirmed: isConfirmation,
                  isCancelled: !isConfirmation,
                },
          );
          setPatientData({ ...patientData, notifications: newNotifications });
          firestore.collection(collections.patients).doc(phoneQuery).update({
            notifications: newNotifications,
          });
        }
        MySwal.fire({
          html: setB(data.fulfillmentText).replaceAll('\n', '<br/>'),
          icon: isError ? 'error' : 'success',
        });
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          text: 'Error: no se pudo confirmar/cancelar el turno. Intente más tarde o comuníquese por otro medio',
          icon: 'error',
        });
      })
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  const notifications = patientData && patientData.notifications;
  const pendingNotifications =
    notifications &&
    notifications
      .filter((e) => moment() < moment(`${e.appDate}${e.appTime}`, 'DD/MM/YYYY HH:mm'))
      .sort((a, b) => {
        if (!a.appDate || !a.appTime || !b.appDate || !b.appTime) return -1;
        const dateA = moment(`${a.appDate}${a.appTime}`, 'DD/MM/YYYY HH:mm');
        const dateB = moment(`${b.appDate}${b.appTime}`, 'DD/MM/YYYY HH:mm');
        return dateA < dateB ? 1 : -1;
      });
  const oldNotifications =
    notifications &&
    notifications
      .filter((e) => moment() > moment(`${e.appDate}${e.appTime}`, 'DD/MM/YYYY HH:mm'))
      .sort((a, b) => {
        if (!a.appDate || !a.appTime || !b.appDate || !b.appTime) return -1;
        const dateA = moment(`${a.appDate}${a.appTime}`, 'DD/MM/YYYY HH:mm');
        const dateB = moment(`${b.appDate}${b.appTime}`, 'DD/MM/YYYY HH:mm');
        return dateA < dateB ? 1 : -1;
      });

  return (
    <Box sx={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <Box
        className={classes.header}
        display="flex"
        width="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Box mr={2}>
          <img src="/logo512.png" width="50" alt="PrestoBots" />
        </Box>
        <Typography component="h1" variant="h6" noWrap className={classes.title}>
          Prestobots
        </Typography>
      </Box>
      <Box
        display="flex"
        maxWidth={small ? '100%' : '700px'}
        mx="auto"
        flexDirection="column"
        p={small ? 2 : 4}
      >
        {!phoneQuery && (
          <Box>
            <Typography>Ingrese su número de telefono para consultar sus recordatorios</Typography>
            <Box my={2}>
              <FormControl>
                <TextField
                  label="Telefono"
                  name="name"
                  required
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                />
              </FormControl>
            </Box>
            <Button
              type="button"
              variant="contained"
              color="primary"
              className={classes.mainBtn}
              onClick={changePhone}
            >
              Aceptar
            </Button>
          </Box>
        )}
        {!loading && (!pendingNotifications || pendingNotifications.length === 0) && (
          <Typography className={classes.privacyPoliciesTitle}>
            No tiene recordatorios pendientes
          </Typography>
        )}

        {phoneQuery && (
          <Box>
            {pendingNotifications && pendingNotifications.length > 0 && (
              <Box mb={2}>
                <Typography className={classes.privacyPoliciesTitle}>
                  Recordatorios pendientes
                </Typography>
              </Box>
            )}
            {pendingNotifications &&
              pendingNotifications.length > 0 &&
              pendingNotifications.map((reminder, index) => (
                <Box key={index}>
                  <Reminder
                    handleCancel={(reminder) => handleSubmit(reminder, false)}
                    handleConfirm={(reminder) => handleSubmit(reminder, true)}
                    reminder={reminder}
                  />
                </Box>
              ))}
            {oldNotifications && oldNotifications.length > 0 && (
              <>
                <Box my={4}>
                  <Divider />
                </Box>
                <Box my={2}>
                  <Typography>Recordatorios anteriores</Typography>
                </Box>
              </>
            )}
            {oldNotifications &&
              oldNotifications.length > 0 &&
              oldNotifications.map((reminder, index) => (
                <Reminder key={index} reminder={reminder} />
              ))}
          </Box>
        )}
      </Box>
      <Box sx={{ width: '100%', p: 2, mt: 'auto' }}>
        Politicas de privacidad:{' '}
        <a href="https://prestobots-panel.firebaseapp.com/privacy" target="__blank">
          https://prestobots-panel.firebaseapp.com/privacy
        </a>
      </Box>
    </Box>
  );
}

Reminder.propTypes = {
  reminder: propTypes.object,
  handleCancel: propTypes.func,
  handleConfirm: propTypes.func,
};

PatientReminders.propTypes = {};

export default PatientReminders;
